import { useEffect } from 'react'
import qbeeHappyTransparent from '@/assets/images/qbee-character/qbee-happy-transparent.png'

interface WelcomeScreenProps {
  onTimeout: () => void
}

export function WelcomeScreen({ onTimeout }: WelcomeScreenProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onTimeout()
    }, 1000)
    return () => clearTimeout(timer)
  }, [onTimeout])

  return (
    <div className='fixed inset-0 z-[60] flex flex-col font-sans'>
      <div className='flex-1 flex flex-col items-center justify-center px-6 text-center'>
        <img src={qbeeHappyTransparent} alt='큐비 캐릭터' className='w-32 h-32 mb-4 animate-bounce' />
        <h2 className='text-[28px] font-bold text-amber-900 mb-2'>드디어 만났구나!</h2>
        <p className='text-[18px] text-amber-700'>나는 큐비야!</p>
      </div>
    </div>
  )
}
